const publicReleaseNotes = {
  "generatedAt": "2026-11-03T17:54:43.338Z",
  "releaseId": "20261103-intervention-revision-r1",
  "releaseLabel": "Release 20261103-intervention-revision-r1",
  "releaseDateEn": "3rd November 2026",
  "releaseDateFr": "3 novembre 2026",
  "en": {
    "sectionEyebrow": "Optional reading",
    "description": "",
    "featuresHeading": "What changed",
    "features": [
      "Fixed a bug that could carry dates, costs and payees from one intervention revision into another.",
      "Added checks to prevent saving or approving revision details belonging to a different intervention."
    ],
    "featurePackages": [
      {
        "title": "Release 20261103-intervention-revision-r1",
        "items": [
          "Fixed a bug that could carry dates, costs and payees from one intervention revision into another.",
          "Added checks to prevent saving or approving revision details belonging to a different intervention."
        ]
      },
      {
        "title": "Release 20261102-ei-payment-appeals-r3",
        "items": [
          "Fixed repeated background appeal checks in Applications and Case workspaces that could contribute to temporary errors opening files.",
          "New and revised interventions inherit their Action Plan’s EI/CRF classification, without another EI lookup at final approval.",
          "Current living-allowance eligibility remains part of the financial assessment; historical plan classification no longer automatically blocks a payment.",
          "Added missing payment evidence document types, including NWAC payment authorization and Vendor EFT forms.",
          "Confirm a Vendor EFT form for the named payee in one action; PATH remembers the selection for later payments in the case.",
          "Case-level evidence can satisfy configured payment requirements without an unnecessary application link."
        ]
      },
      {
        "title": "Release 20261031-payments-casework-r2",
        "items": [
          "Prepare payment requests as editable emails within the client file, with one Payments widget for outstanding requests, history and follow-up.",
          "Choose supporting documents from the case or upload them, with configurable evidence checks and secure time-limited download bundles.",
          "Payment entry suggests amounts and periods; intervention closeout shows committed requests as an editable actual-cost suggestion.",
          "Intervention and Action Plan dialogs use compact summaries, clear field groups and expandable details.",
          "Fixed client reassignment targeting, document type handling and payment handoff recovery.",
          "Improved notification delivery, access checks and automatic refresh; restored saved application progress in the applicant portal.",
          "Fixed an Activity Report dependency that could prevent the report from loading."
        ]
      }
    ],
    "knownIssuesHeading": "Known Bugs",
    "knownIssues": [],
    "comingNextHeading": "What's Coming",
    "comingNext": []
  },
  "fr": {
    "sectionEyebrow": "Lecture optionnelle",
    "description": "",
    "featuresHeading": "Ce qui a change",
    "features": [
      "Correction d’un bogue pouvant transférer les dates, les coûts et les bénéficiaires d’une révision d’intervention à une autre.",
      "Ajout de contrôles empêchant l’enregistrement ou l’approbation de détails appartenant à une autre intervention."
    ],
    "featurePackages": [
      {
        "title": "Release 20261103-intervention-revision-r1",
        "items": [
          "Correction d’un bogue pouvant transférer les dates, les coûts et les bénéficiaires d’une révision d’intervention à une autre.",
          "Ajout de contrôles empêchant l’enregistrement ou l’approbation de détails appartenant à une autre intervention."
        ]
      },
      {
        "title": "Release 20261102-ei-payment-appeals-r3",
        "items": [
          "Correction des vérifications répétées des appels en arrière-plan dans les espaces Demandes et Dossiers, qui pouvaient contribuer à des erreurs temporaires à l’ouverture des dossiers.",
          "Les interventions nouvelles ou révisées héritent de la classification AE/Trésor du plan d’action, sans nouvelle vérification de l’AE à l’approbation finale.",
          "L’admissibilité actuelle à l’allocation de subsistance demeure évaluée dans l’analyse financière; la classification historique du plan ne bloque plus automatiquement un paiement.",
          "Ajout des types de justificatifs de paiement manquants, notamment les formulaires d’autorisation NWAC et de dépôt direct des fournisseurs.",
          "Confirmez en une seule action le formulaire bancaire du bénéficiaire nommé; PATH conserve ce choix pour les paiements suivants du dossier.",
          "Les justificatifs conservés au niveau du dossier peuvent satisfaire aux exigences sans lien inutile avec une demande."
        ]
      },
      {
        "title": "Release 20261031-payments-casework-r2",
        "items": [
          "Préparez les demandes de paiement sous forme de courriels modifiables dans le dossier client, avec un widget Paiements regroupant demandes en cours, historique et suivi.",
          "Choisissez des documents du dossier ou téléversez-les, avec des exigences configurables et des lots accessibles par lien sécurisé à durée limitée.",
          "La saisie propose des montants et des périodes; la clôture affiche les demandes engagées comme suggestion de coût réel modifiable.",
          "Les fenêtres Intervention et Plan d’action présentent des résumés compacts, des champs regroupés et des détails dépliables.",
          "Correction du ciblage des réaffectations, des types de documents et de la récupération après transmission d’un paiement.",
          "Amélioration des notifications, des contrôles d’accès et de l’actualisation; rétablissement de la progression des demandes sauvegardées dans le portail.",
          "Correction d’une dépendance pouvant empêcher le chargement du rapport d’activité."
        ]
      }
    ],
    "knownIssuesHeading": "Problemes connus",
    "knownIssues": [],
    "comingNextHeading": "A venir",
    "comingNext": []
  }
};

export default publicReleaseNotes;
